import { DynamicFormV2Palette } from "@mui/material";

export type FormDividerComponentTokenType = {
  borderColor: string;
};

export const assignDividerComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], mode: "light" | "dark") => {
  const isLightMode = mode === "light";

  return {
    borderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.supershy,
  } as FormDividerComponentTokenType;
};
